module.exports = __webpack_public_path__ + "img/araare-sketchwork-small.7cd6e520.png";